document.addEventListener('DOMContentLoaded', function () {
  const titles = document.querySelectorAll('.sidebar__title');

  titles.forEach(function (title) {
    title.addEventListener('click', function () {
      const box = title.closest('.sidebar__box');
      if (box) {
        const isActive = box.classList.toggle('is-active');

        if (isActive && window.innerWidth <= 768) {
          box.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });
});
